import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_DOUBLE_OPT_IN_ENABLED = createFcmConfig('double_opt_in_enabled', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
